import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={120}
        height={120}
        viewBox="0 0 526 526"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M516.798 455.5H481.798V201.8C481.798 177.7 462.198 158 437.998 158H287.598C288.598 155.3 289.198 152.3 289.198 149.2C289.198 134.7 277.398 123 262.998 123C248.598 123 236.798 134.8 236.798 149.2C236.798 152.3 237.398 155.2 238.398 158H87.9984C63.8984 158 44.1984 177.6 44.1984 201.8V455.5H9.19843C4.39843 455.5 0.398438 459.4 0.398438 464.3C0.398438 498.1 27.8984 525.6 61.5984 525.6H464.098C497.898 525.6 525.298 498.1 525.298 464.3C525.498 459.4 521.598 455.5 516.798 455.5ZM254.198 149.3C254.198 144.5 258.098 140.5 262.998 140.5C267.898 140.5 271.798 144.4 271.798 149.3C271.798 154.2 267.898 158.1 262.998 158.1C258.098 158.1 254.198 154.1 254.198 149.3ZM61.7984 201.8C61.7984 187.3 73.5984 175.6 87.9984 175.6H437.998C452.498 175.6 464.198 187.4 464.198 201.8V455.5H61.7984V201.8ZM464.198 508H61.7984C40.6984 508 22.9984 492.9 18.8984 473H507.098C503.098 492.9 485.398 508 464.198 508Z"
            fill="url(#paint0_linear_8042_28134)"
        />
        <path
            d="M437.999 193H87.9992C83.1992 193 79.1992 196.9 79.1992 201.8V429.3C79.1992 434.1 83.0992 438.1 87.9992 438.1H437.999C442.799 438.1 446.799 434.2 446.799 429.3V201.8C446.799 196.9 442.799 193 437.999 193ZM429.199 420.5H96.7992V210.5H429.299V420.5H429.199Z"
            fill="url(#paint1_linear_8042_28134)"
        />
        <path
            d="M184.498 273.9L205.698 361.3C205.798 361.6 205.998 361.9 206.098 362.2C203.298 366.4 201.698 371.3 201.698 376.7C201.698 391.2 213.498 402.9 227.898 402.9C242.298 402.9 254.098 391.1 254.098 376.7C254.098 373.6 253.498 370.7 252.498 367.9H273.198C272.198 370.6 271.598 373.6 271.598 376.7C271.598 391.2 283.398 402.9 297.798 402.9C312.198 402.9 323.998 391.1 323.998 376.7C323.998 370.9 321.998 365.5 318.798 361.2L344.898 274.2C345.698 271.5 345.198 268.7 343.498 266.5C341.898 264.3 339.298 263 336.498 263H199.798L192.698 234.6C191.698 230.7 188.198 228 184.198 228H140.398V245.5H177.298L184.498 273.9ZM236.698 376.8C236.698 381.6 232.798 385.6 227.898 385.6C222.998 385.6 219.098 381.7 219.098 376.8C219.098 371.9 222.998 368 227.898 368C232.798 368 236.698 371.9 236.698 376.8ZM297.998 385.5C293.198 385.5 289.198 381.6 289.198 376.7C289.198 371.8 293.098 367.9 297.998 367.9C302.898 367.9 306.798 371.8 306.798 376.7C306.798 381.6 302.798 385.5 297.998 385.5ZM324.998 280.5L303.998 350.5H221.098L204.098 280.5H324.998Z"
            fill="url(#paint2_linear_8042_28134)"
        />
        <path
            d="M365 37.7004C308.7 -11.6996 217.2 -11.6996 161 37.7004L172.5 50.9004C222.4 7.1004 303.6 7.1004 353.5 50.9004L365 37.7004Z"
            fill="url(#paint3_linear_8042_28134)"
        />
        <path
            d="M205 107.4L216 121C241.9 100.2 284.1 100.2 310 121L321 107.4C289 81.7 237 81.7 205 107.4Z"
            fill="url(#paint4_linear_8042_28134)"
        />
        <path
            d="M338.899 72.8002C297.099 35.0002 228.999 35.0002 187.199 72.8002L198.899 85.8002C234.299 53.8002 291.799 53.8002 327.199 85.8002L338.899 72.8002Z"
            fill="url(#paint5_linear_8042_28134)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_8042_28134"
                x1={52.3214}
                y1={-69.9478}
                x2={371.019}
                y2={613.502}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.1155} stopColor="#01E9BD" />
                <stop offset={0.1646} stopColor="#01E1BC" />
                <stop offset={0.243} stopColor="#01C9B8" />
                <stop offset={0.3408} stopColor="#01A4B2" />
                <stop offset={0.453} stopColor="#0270AA" />
                <stop offset={0.5408} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_8042_28134"
                x1={98.5079}
                y1={-37.2526}
                x2={369.034}
                y2={542.892}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.0380284} stopColor="#01E9BD" />
                <stop offset={0.0960584} stopColor="#01D9BA" />
                <stop offset={0.4326} stopColor="#027EAD" />
                <stop offset={0.5847} stopColor="#025AA7" />
                <stop offset={0.6448} stopColor="#024EA5" />
                <stop offset={0.7296} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_8042_28134"
                x1={165.969}
                y1={95.3405}
                x2={315.327}
                y2={415.641}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.0897} stopColor="#01E9BD" />
                <stop offset={0.1044} stopColor="#01E3BC" />
                <stop offset={0.2387} stopColor="#01B2B5" />
                <stop offset={0.372} stopColor="#028AAE" />
                <stop offset={0.5019} stopColor="#026BA9" />
                <stop offset={0.6275} stopColor="#0254A6" />
                <stop offset={0.7468} stopColor="#0247A4" />
                <stop offset={0.8531} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_8042_28134"
                x1={242.371}
                y1={-6.56581}
                x2={298.35}
                y2={113.48}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.1155} stopColor="#01E9BD" />
                <stop offset={0.1905} stopColor="#01E3BC" />
                <stop offset={0.2895} stopColor="#01D3BA" />
                <stop offset={0.4018} stopColor="#01B7B5" />
                <stop offset={0.5239} stopColor="#0291AF" />
                <stop offset={0.6526} stopColor="#0261A8" />
                <stop offset={0.7254} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint4_linear_8042_28134"
                x1={194.491}
                y1={-39.4942}
                x2={292.254}
                y2={170.159}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.1626} stopColor="#01E9BD" />
                <stop offset={0.2589} stopColor="#01E4BC" />
                <stop offset={0.3668} stopColor="#01D7BA" />
                <stop offset={0.4803} stopColor="#01C0B7" />
                <stop offset={0.5976} stopColor="#01A1B2" />
                <stop offset={0.718} stopColor="#0279AC" />
                <stop offset={0.8393} stopColor="#0248A4" />
                <stop offset={0.8531} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint5_linear_8042_28134"
                x1={219.066}
                y1={-21.4576}
                x2={282.468}
                y2={114.51}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.3096} stopColor="#01E9BD" />
                <stop offset={0.3841} stopColor="#01E1BC" />
                <stop offset={0.5031} stopColor="#01C9B8" />
                <stop offset={0.6516} stopColor="#01A4B2" />
                <stop offset={0.822} stopColor="#0270AA" />
                <stop offset={0.9553} stopColor="#0242A3" />
            </linearGradient>
        </defs>
    </svg>
);
export default SVGComponent;
